import { logout } from '../firebase';
import { Button, IconButton } from '@chakra-ui/react';
import { FaSignOutAlt } from 'react-icons/fa';
import mixpanel from 'mixpanel-browser';
import { useNavigate } from 'react-router-dom';

const LogoutButton = ({ isCompact }) => {
  const navigate = useNavigate();

  const handleLogoutClick = async () => {
    // TODO: handle other logout logic
    await logout();
    if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
      mixpanel.reset();
    }
    navigate('/login');
    window.location.reload(true);
  };

  if (isCompact) {
    return (
      <IconButton
        aria-label="Logout"
        icon={<FaSignOutAlt />}
        variant="ghost"
        colorScheme="gray"
        size="sm"
        onClick={handleLogoutClick}
      />
    );
  }

  return (
    <Button
      mt="20px"
      mb="20px"
      variant="solid"
      colorScheme="red"
      onClick={handleLogoutClick}
    >
      Logout
    </Button>
  );
};

export default LogoutButton;
